import script from "./AssetMaterialProperties.vue?vue&type=script&setup=true&lang=ts"
export * from "./AssetMaterialProperties.vue?vue&type=script&setup=true&lang=ts"

import "./AssetMaterialProperties.vue?vue&type=style&index=0&id=a6e69e0e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a6e69e0e"]])

export default __exports__